<script>
import {ref} from "vue";
import {useRoute} from "vue-router";
import StarRating from "vue-star-rating";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";
import FooterPage from "@/components/assetComponents/FooterPage.vue";

export default {
  name: "CommentProducts",
  components: {FooterPage, NavbarPage, LoadingPage, StarRating},
  setup(){

    let id = useRoute().params.prod_id
    let type = useRoute().params.type

    let loading = ref(false)

    let comments = ref([])
    function load_comments() {
      loading.value = true
      FreeWorld.Heisenberg({ action: type, item_id: id} , 'item_comments' ).then((result)=>{

        loading.value = false
        let res = result.data
        comments.value = res

      }).catch((result) => {
        loading.value = false
     Swals.Catch(result , load_comments)
      })

    }
    load_comments()

    return{

      comments,
      loading,
      type,

    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>
  <div dir="ltr" id="main" :class="loading ? 'activeClass' : '' " class="bg-main">
    <div class="div-top-arrow bg-color d-flex align-items-center ">

      <p class="m-0">
        نظرات محصول
      </p>

      <div onclick="history.back()">
        <img class="svg-arrow" src="../assets/img/back.svg" alt="">
      </div>

    </div>
    <br>
    <br>
    <br>

    <div v-if="comments.length == 0 " class="p-body w-100 d-flex flex-column justify-content-center align-items-center"
         style="height: 60vh">
      <div class="d-flex flex-column align-items-center">
        <img style="width: 70px" src="../assets/img/shop_none.svg" alt="">
        <br>
        <p class="font-4 ">
          ...در حال حاضر نظری برای این محصول وجود ندارد
        </p>
      </div>
    </div>


    <div v-else class="p-body my-3">

      <div v-for="(item , i) in comments" :key="i" class="bg-white rounded-4 p-body py-3 px-2 mb-3">
        <div class="d-flex align-items-center justify-content-between">
          <div>
            <star-rating :star-size="20" class="position-relative overflow-hidden" :read-only="true" :show-rating="false" v-model:rating="item.score" :animate="false"></star-rating>
          </div>

          <div class="d-flex align-items-center">
            <p class="font-4 m-0 mx-3 font-bold">{{ item.date }}</p>

            <p class="font-4 m-0 font-bold">{{ item.name }}</p>
          </div>
        </div>
        <hr>
        <p class="m-0 font-4 text-end">{{ item.comment }}</p>
      </div>

    </div>


  </div>

  <div id="web" :class="loading ? 'activeClass' : '' " class="bg-main">
  <NavbarPage></NavbarPage>

    <div style="background-color: white" class="rounded-4 font-bold font-color p-3 mb-5 w-75 ma-auto">
      <span v-if="type === 'store'">نظرات فروشگاه</span>
      <span v-else>نظرات محصول</span>
    </div>

    <div style="height: 70vh" class="w-75 overflow-y-scroll bg-white rounded-4 p-4 ma-auto">
    <div v-if="comments.length === 0 " class="p-body w-100 d-flex flex-column justify-content-center align-items-center"
         style="height: 60vh">
      <div class="d-flex flex-column align-items-center">
        <img style="width: 70px" src="../assets/img/shop_none.svg" alt="">
        <br>
        <span v-if="type === 'store'">در حال حاضر نظری برای این فروشگاه وجود ندارد ...</span>
        <span v-else>در حال حاضر نظری برای این محصول وجود ندارد ...</span>
      </div>
    </div>

    <div v-else class="">
      <div v-for="(item , i) in comments" :key="i" class="bg-white shadow-costom rounded-4 p-body py-3 px-2 mb-3">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <p class="font-4 m-0 font-bold">{{ item.name }}</p>

            <p class="font-4 m-0 mx-3 font-bold">{{ item.date }}</p>
          </div>

          <div>
            <star-rating :star-size="20" class="position-relative overflow-hidden" :read-only="true" :show-rating="false" v-model:rating="item.score" :animate="false"></star-rating>
          </div>
        </div>
        <hr>
        <p class="m-0 font-4">{{ item.comment }}</p>
      </div>
    </div>
  </div>

    <FooterPage></FooterPage>
  </div>

</template>

<style scoped>

.stars {
  width: 20px;
}
.button_div {
  height: 80px;
  position: fixed;
  bottom: 0;
  max-width: 700px;
}

</style>